import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Skeleton,
} from "@mui/material";

// The same tile geometry as ServiceCard, so the list does not jump when the
// catalogue arrives.
const ServiceSkeleton: React.FC = () => {
  return (
    <Card
      variant="outlined"
      sx={{ width: "100%", height: "100%", borderRadius: 3.5 }}
    >
      <CardActionArea
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 1.5,
          p: 1.75,
          height: "100%",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={44}
          height={44}
          sx={{ borderRadius: "12px", flexShrink: 0 }}
        />
        <CardContent
          sx={{ display: "flex", flexDirection: "column", flex: 1, p: 0 }}
        >
          <Skeleton width="80%" height={20} />
          <Skeleton width="100%" height={18} />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ServiceSkeleton;
